import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from "./plugins/vuetify";
import * as VueGoogleMaps from 'vue2-google-maps';


import "./assets/css/font.css";
import "./assets/css/styles.scss";
import { apiFire } from './plugins/apiFire';


Vue.prototype.$apiFire = apiFire
Vue.config.productionTip = false
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCcWmzuZ-P3FANdkdqDVUNTCEVLMcwkYjw',
    libraries: 'places',
  }
})

const v = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
})


// when router is ready then render app
router.onReady(() => {
  v.$mount("#app");
});